import React from 'react';
import { Grid } from '@material-ui/core';

import LocationSearchInput from '~/pages/NewOpportunity/components/LocationSearchInput';
import { AddressComponent } from '~/types';

interface LocationStepProps {
  requireDestination: boolean;
  onOriginCoordinatesChange: (coords?: google.maps.LatLngLiteral) => void;
  onDestinationCoordinatesChange: (coords?: google.maps.LatLngLiteral) => void;
  onOriginAddressChange: (address: AddressComponent) => void;
  onDestinationAddressChange: (address: AddressComponent) => void;
}

export default function LocationStep({
  requireDestination,
  onOriginCoordinatesChange,
  onDestinationCoordinatesChange,
  onOriginAddressChange,
  onDestinationAddressChange,
}: LocationStepProps) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <LocationSearchInput
          label='Endereco de origem'
          setLatLng={onOriginCoordinatesChange}
          fnSetAddress={onOriginAddressChange}
        />
      </Grid>

      {requireDestination && (
        <Grid item xs={12} md={6}>
          <LocationSearchInput
            label='Endereco de destino'
            setLatLng={onDestinationCoordinatesChange}
            fnSetAddress={onDestinationAddressChange}
          />
        </Grid>
      )}
    </Grid>
  );
}
